export const rowsPerPageOptions: string[] = ['5', '10', '25', '50', '100'];
export const defaultRowPerPageOption: string = '25';
export const initialPageValue: number = 1;
